module.exports = __webpack_public_path__ + "7bbcd1dec779563e79dbdc8cfb7b7059.svg";